export const parentTypeItems = [
  { text: "Mother", value: "mother" },
  { text: "Father", value: "father" },
  { text: "Grandmother", value: "grandma" },
  { text: "Grandfather", value: "grandpa" },
  { text: "Aunt", value: "aunt" },
  { text: "Uncle", value: "uncle" },
  { text: "Sister", value: "sister" },
  { text: "Brother", value: "brother" },
  { text: "Other", value: "other" },
];
